import { useState } from "react";
import { useAuth } from "../auth";

export function LoginPage() {
  const { user, allowed, signIn, signInDev, signOut } = useAuth();
  const [err, setErr] = useState<string | null>(null);
  const [devEmail, setDevEmail] = useState("daniel.dmds1@gmail.com");

  const semAcesso = user && allowed === false;

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <div className="card w-full max-w-sm text-center">
        <h1 className="text-lg font-bold text-slate-900">Painel · Farmácias</h1>
        <p className="mt-1 text-sm text-slate-500">Acesso restrito ao time de suporte.</p>

        {semAcesso ? (
          <div className="mt-6 space-y-3">
            <p className="rounded-lg bg-amber-50 p-3 text-sm text-amber-800">
              <strong>{user.email}</strong> não está na lista de acesso. Fale com quem
              administra o painel.
            </p>
            <button className="btn-ghost w-full" onClick={() => void signOut()}>
              Trocar de conta
            </button>
          </div>
        ) : (
          <button
            className="btn-primary mt-6 w-full"
            onClick={() => {
              setErr(null);
              signIn().catch((e) => setErr(e instanceof Error ? e.message : "Falha no login"));
            }}
          >
            Entrar com Google
          </button>
        )}

        {err && <p className="mt-3 text-sm text-red-600">{err}</p>}

        {signInDev && !semAcesso && (
          <div className="mt-4 space-y-2 border-t border-dashed border-slate-200 pt-4">
            <p className="text-xs text-slate-400">Modo emulador</p>
            <input className="input text-sm" value={devEmail} onChange={(e) => setDevEmail(e.target.value)} />
            <button
              className="btn-ghost w-full text-sm"
              onClick={() => {
                setErr(null);
                signInDev(devEmail).catch((e) => setErr(e instanceof Error ? e.message : "falha"));
              }}
            >
              Entrar (emulador)
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
